export default class HealthCoverage {
  coverageCode: string | null
  sumInsured: string | null

  constructor(data: HealthCoverage) {
    if (!data.coverageCode) throw new Error('coverageCode is required')

    this.coverageCode = data.coverageCode
    this.sumInsured = data.sumInsured ?? null
  }
}
